import { memo } from 'react';
import { Container, Col, Row, } from 'react-bootstrap';
import moment from 'moment';
import { BzCard, BzChip, BzHeading } from '../../../../components';
import NfoDetails from './NfoDetails';
import { handleModal } from "../../../../redux/actions/modals";
import { useDispatch } from "react-redux";


const NfoCard = ({ exploreFundsNfo, setShowDetailPageNfo, setNfoDetails, nfoDetails }) => {
    const dispatch = useDispatch();
    const handleOnNfoDetails = (element) => {
        dispatch(handleModal([{ 'NFO_DETAILS': true }]));
        setNfoDetails(element);
    };


    return (

        <Container fluid className='p-0'>
            <Row className='g-0 pt-4 pe-0'>
                <Col className='d-flex'>
                    <div className='d-flex justify-content-center align-items-center'>
                        <BzHeading className='font-medium font-size6 color-text'>NFO</BzHeading>
                        <div className='icon-16 icon-info icon-dark ms-2'>&nbsp;</div>
                    </div>

                    <div className='d-flex justify-content-center align-items-center ms-4'>
                        <div className='d-flex align-items-center cursor-pointer' onClick={() => { setShowDetailPageNfo(true); }}>
                            <BzHeading className='font-medium font-size4 color-text'>View All</BzHeading>
                            <div className='icon-12 icon-forward-arrow icon-dark ms-2'>&nbsp;</div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row className='g-0 pb-3'>
                <Col>
                    <div className='text-secondary'>Invest in New Fund Offering</div>
                </Col>
            </Row>

            <Row className='g-0'>
                <Col>
                    {/* Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start */}
                    <div className='mutual-funds-nfo-card-wrap'>
                        {exploreFundsNfo?.map((element, i) => (
                            <BzCard key={i} className='mutual-funds-nfo-card cursor-pointer' onClick={() => handleOnNfoDetails(element)}>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size5 color-text text-wrap mutual-funds-nfo-card-title'>{element.scheme_name}</div>
                                        <div className='chips-wrap flex-wrap'>
                                            {/* {element?.category?.map((data, i) =>
                                                <BzChip key={i} className='chips font-medium font-size2 text-uppercase me-2 primary-chip'>{data}</BzChip>
                                            )} */}
                                            <BzChip className='chips font-medium font-size2 text-uppercase me-2 primary-chip'>{element.scheme_type}</BzChip>
                                        </div>
                                        <Row className='g-0 text-wrap'>
                                            <Col md={6}>
                                                <div className='font-regular font-size2 color-subtext'>Min. Invesment</div>
                                                <div className='font-medium font-size4 color-text'>&#8377;{element.min_purchase_amount_for_new_investors}</div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='font-regular font-size2 color-subtext'>Fund House</div>                                     
                                                <div className='font-medium font-size2 color-text'>{element.amc_name}</div>                                                                                 
                                            </Col>
                                        </Row>
                                        <Row className='g-0'>
                                            <Col className='d-flex pt-3'>
                                                {/* <div className='event-date-wrap warning-event'>{element.date}</div> */}
                                                <div className='event-date-wrap warning-event'>{moment(element?.launch_date).format("DD MMM 'YY")} - {moment(element?.end_date).format("DD MMM 'YY")}</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>                              
                            </BzCard>
                        ))}
                    </div>
                    {/* Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End */}
                </Col>

                <NfoDetails nfoDetails={nfoDetails} />
            </Row> 
        </Container>

    );
};

export default memo(NfoCard);
